// import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
// import { store } from '@/store/store';
// import { forceLogout } from '../helpers/forceLogout';
// import { STORAGE_KEYS } from '@/constants/storageKeys';

// // 建立沒有 token 的公開 api 實例
// export const publicClient = axios.create({
//   baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'multipart/form-data',
//   },
// });

// // 建立有 token 的 axios 實例
// export const apiClient = axios.create({
//   baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'multipart/form-data',
//   },
// });

// // LocalStorage 取得 token
// export function getToken() {
//   return localStorage.getItem('token');
// }

// export function getRefreshToken() {
//   return localStorage.getItem('refreshToken');
// }

// export function setToken(token: string) {
//   localStorage.setItem('token', token);
// }

// // 刷新 token
// let isRefreshing = false;
// let failedQueue: {
//   resolve: (value?: unknown) => void;
//   reject: (reason?: unknown) => void;
// }[] = [];

// function processQueue(error: unknown, token: string | null = null) {
//   failedQueue.forEach((prom) => {
//     if (error) {
//       prom.reject(error);
//     } else {
//       prom.resolve(token);
//     }
//   });
//   failedQueue = [];
// }

// // ✨ 加上 Request 攔截器（帶 Authorization）
// apiClient.interceptors.request.use(
//   (config: InternalAxiosRequestConfig) => {
//     const token = getToken();
//     if (token && config.headers) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // ✨ 加上 Response 攔截器（自動刷新 token）
// apiClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config as AxiosRequestConfig & {
//       _retry?: boolean;
//     };

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         }).then((token) => {
//           if (originalRequest.headers) {
//             originalRequest.headers.Authorization = `Bearer ${token}`;
//           }
//           return apiClient(originalRequest);
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const { data } = await publicClient.post('/auth/refresh', {
//           refreshToken: getRefreshToken(),
//         });

//         const { token } = data;
//         setToken(token);

//         // ✅ 更新 tokenExpiresAt（很重要）
//         const expiresInSec = data.expires_in ?? 3600;
//         localStorage.setItem(STORAGE_KEYS.tokenExpiresAt, String(Date.now() + expiresInSec * 1000));

//         apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
//         processQueue(null, token);

//         if (originalRequest.headers) {
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//         }
//         return apiClient(originalRequest);
//       } catch (err) {
//         processQueue(err, null);
//         forceLogout(store.dispatch);
//         return Promise.reject(err);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   }
// );
import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { store } from '@/store/store';
import { forceLogout } from '../helpers/forceLogout';
import { STORAGE_KEYS } from '@/constants/storageKeys';

// 建立沒有 token 的公開 api 實例
export const publicClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// 建立有 token 的 axios 實例
export const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// LocalStorage 取得 token
export function getToken() {
  return localStorage.getItem('token');
}

export function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

export function setToken(token: string) {
  localStorage.setItem('token', token);
}

// =====================
// ✅ 刷新 token：抽成共用
// =====================
let isRefreshing = false;
let failedQueue: {
  resolve: (token: string) => void;
  reject: (reason?: unknown) => void;
}[] = [];

function processQueue(error: unknown, token: string | null = null) {
  failedQueue.forEach((p) => {
    if (error) p.reject(error);
    else p.resolve(token!);
  });
  failedQueue = [];
}

/**
 * ✅ 任何地方想刷新 token 都呼叫它：
 * - 401 interceptor 兜底會用
 * - ExpiryWatcher 主動刷新也會用
 */
export async function refreshAccessToken(): Promise<string> {
  if (isRefreshing) {
    return new Promise<string>((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    });
  }

  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    // 沒 refreshToken 不可能續登入，只能登出
    forceLogout(store.dispatch);
    throw new Error('Missing refreshToken');
  }

  isRefreshing = true;

  try {
    const { data } = await publicClient.post('/auth/refresh', { refreshToken });

    const token: string = data.token;
    setToken(token);

    // ✅ 更新 tokenExpiresAt（很重要）
    const expiresInSec: number = data.expires_in ?? 3600;
    localStorage.setItem(STORAGE_KEYS.tokenExpiresAt, String(Date.now() + expiresInSec * 1000));

    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;

    processQueue(null, token);
    return token;
  } catch (err) {
    processQueue(err, null);
    forceLogout(store.dispatch);
    throw err;
  } finally {
    isRefreshing = false;
  }
}

// ✨ Request 攔截器（帶 Authorization）
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✨ Response 攔截器（401 時自動刷新 token）
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config as AxiosRequestConfig & {
      _retry?: boolean;
    };

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const token = await refreshAccessToken();

        if (originalRequest.headers) {
          originalRequest.headers.Authorization = `Bearer ${token}`;
        }
        return apiClient(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);
